import { GetUsersPreferencesPipeSeriesStatus200 } from "@imi/api-client/index.js";
import { z } from "zod/v4";

export const pipeSeriesPreferenceSchema = z.object({
  pipes: z.string(),
  pipeSeries: z.string(),
});

export type PipeSeriesPreference = {
  pipes: string | null;
  pipeSeries: string | null;
};

export function buildPipeSeriesPreference(
  preferences: GetUsersPreferencesPipeSeriesStatus200 | undefined,
): PipeSeriesPreference {
  if (!preferences)
    return {
      pipes: null,
      pipeSeries: null,
    };

  if (preferences.pipeSeriesSource === "custom") {
    return {
      pipes: preferences.pipe ? preferences.pipe.id.toString() : null,
      pipeSeries: preferences.pipeSeries
        ? preferences.pipeSeries.id.toString()
        : null,
    };
  }

  return {
    pipes: preferences.pipeId,
    pipeSeries: preferences.pipeSeriesId,
  };
}
